import i18n from '../../language/index'
import {
  create_title
} from '@/base/titleData';
import {
  icons_init
} from '@/base/base';
import pageData from '@/base/pageData'
import { box_shadow_style_add, getCommonStyle} from "@/base/widgets_data_compatible";
export default {
  img_effects: {
    id: 1,
    formData: {
      effect: 0,//当前选中的特效
      border: {
        radio_val: 'default',
        default: {
          borderWidth: 2,
          borderColor: "rgba(0, 0, 0, 1)",
        },
        custom: {
          borderWidth: 2,
          borderColor: "rgba(0, 0, 0, 1)",
        }
      },
      background: {
        radio_val: 'default',
        default: {
          color: "rgba(255, 255, 255, 0)",
        },
        custom: {
          color: "rgba(255, 255, 255, 1)",
        }
      },
      direction: 'left'
    }
  },
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_infor: {
    marginTop: '0%',
    marginLeft: '0%',
    marginRight: '0%',
    marginBottom: '0%',
  },
  pc_widgets_infor: {
    // shadowVisible: 'false', // 这个字段不在使用了 组合阴影
    ...box_shadow_style_add, // 4.6.7 之后组合阴影要使用这个字段
    //图片宽度
    img_size: {
      radio_val: 'default',
      default: {
        widthPercent: 25,
        heightPercent: 25,
      },
      custom: {
        widthPercent: 25,
        heightPercent: 25,
      }
    },
    borderRadius: {
      ...getCommonStyle().borderRadius
    },
    defaultBackgroundColor: {
      style_0: '#fff',
      style_1: '#fff',
      style_2: '#f2f2f2',
      style_3: '#eee'
    },

    set_style: {
      background: {
        radio_val: 'default',
        default: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
          seColor: 'rgba(255, 255, 255,1)',
          img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        },
        custom: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
          seColor: 'rgba(255, 255, 255,1)',
          img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        }
      },
    },

    icon_background: {
      radio_val: 'default',
      default: {
        type: 'color', // 背景设置-类型
        img: '', // 背景设置-图片的URL
        color: 'rgba(255, 181, 54,1)', // 背景设置-颜色
        img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'cover',
        background_repeat: 'no-repeat',
        background_position: 'center center' //图片位置
      },
      custom: {
        type: 'color', // 背景设置-类型
        img: '', // 背景设置-图片的URL
        color: 'rgba(255, 181, 54,1)', // 背景设置-颜色
        img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'cover',
        background_repeat: 'no-repeat',
        background_position: 'center center' //图片位置
      }
    },


    //图片缩放
    backgroundSize: {
      radio_val: 'default',
      default: {
        backgroundSize: 'cover'
      },
      custom: {
        backgroundSize: 'auto'
      }
    },
    //图片描述
    alt_display: 'true',

    //标题对象
    title: create_title('Icon & Text'),
    page: pageData,
    //每行个数
    col_num: {
      radio_val: 'default',
      default: {
        value: '4',
      },
      custom: {
        value: '4',
      }
    },

    //每行间距
    padding: {
      radio_val: 'default',
      default: {
        paddingTop: '10%',
        paddingLeft: '10%',
        padding: '10%',
      },
      custom: {
        paddingTop: '0%',
        paddingLeft: '0%',
        padding: 0
      }
    },

    titleFont: {
      radio_val: 'default',
      default: {
        fontSize: 16,
        fontWidth: 'normal',
        fontColor: 'rgba(50,50,50,1)',
        selectColor: 'rgba(50,50,50,1)',
        fontSeColor: 'rgba(50,50,50,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        fontStyle: '',
        fontWeight: 'normal',
        fontItalics: 'normal',
        fontUnderline: 'none',
        linear_gradient: {
          start_color: "rgba(0,120,215,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        fontSize: 16,
        fontWidth: 'normal',
        fontColor: 'rgba(50,50,50,1)',
        selectColor: 'rgba(50,50,50,1)',
        fontSeColor: 'rgba(50,50,50,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        fontStyle: '',
        fontWeight: 'normal',
        fontItalics: 'normal',
        fontUnderline: 'none',
        linear_gradient: {
          start_color: "rgba(0,120,215,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
    },

    summaryFont: {
      radio_val: 'default',
      default: {
        fontSize: 14,
        fontWidth: 'normal',
        fontColor: 'rgba(153,153,153,1)',
        selectColor: 'rgba(153,153,153,1)',
        fontSeColor: 'rgba(153,153,153,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        fontStyle: '',
        fontWeight: 'normal',
        fontItalics: 'normal',
        fontUnderline: 'none',
        linear_gradient: {
          start_color: "rgba(153,153,153,1)",
          end_color: "rgba(20, 20, 20,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        fontSize: 14,
        fontWidth: 'normal',
        fontColor: 'rgba(153,153,153,1)',
        selectColor: 'rgba(153,153,153,1)',
        fontSeColor: 'rgba(153,153,153,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        fontStyle: '',
        fontWeight: 'normal',
        fontItalics: 'normal',
        fontUnderline: 'none',
        linear_gradient: {
          start_color: "rgba(153,153,153,1)",
          end_color: "rgba(20, 20, 20,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
    }

  },
  mb_widgets_infor: {
    //图片宽度
    img_size: {
      radio_val: 'default',
      default: {
        widthPercent: 25,
        heightPercent: 25,
      },
      custom: {
        widthPercent: 25,
        heightPercent: 25,
      }
    },
    //图片描述
    alt_display: 'true',

    //标题对象
    title: create_title('Icon & Text'),

    //每行个数
    col_num: {
      radio_val: 'default',
      default: {
        value: 1,
      },
      custom: {
        value: 1,
      }
    },


  },
  listArr: {
    type: 'custom',
    module_style: '0',
    //直接添加的
    custom: [...icons_init({
      title: i18n.t('widgets_basic_development_history_edit_497'),
      summary: i18n.t('widgets_basic_icon_combination_edit_587')
    })],
    //选择图册
    atlas_id: 0,
    iconAlign: 'default'
  },
}



// WEBPACK FOOTER //
// ./src/widgets/basic_icon_combination/style.js